
    /** Generated by webpack-jst-loader */
    (function() {
      window.JST || (window.JST = {});
      window.JST["app_base/modules/shroud/templates/layout"] = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class='overlay main-overlay'>\n  <div class='shroud-header'>\n    <div class=\"userMenu\"></div>\n    <button\n      aria-label=\"Close moment\"\n      class=\"close-shroud\"\n      tabindex=0>\n    </div>\n  <section id='shroud_content'></section>\n</div>\n";
},"useData":true});
    }).call(this);
  